import { subtopicRepositoryImplementation } from '@shared/infrastructure/http/repositories/subtopic/subtopicRepositoryImplementation';
import { Subtopic } from './subtopic.aggregate';

export interface SubtopicRepository {
  getSubtopics: (
    countryCode: string,
    languageCode: string,
    topicId: number
  ) => Promise<Subtopic[]>;
  getAllSubtopics: (
    countryCode: string,
    languageCode: string
  ) => Promise<Subtopic[]>;
  getSubtopic: (
    countryCode: string,
    languageCode: string,
    subtopicId: number
  ) => Promise<Subtopic>;
  updateSubtopic: (
    countryCode: string,
    languageCode: string,
    data: Subtopic
  ) => Promise<void>;
  createSubtopic: (
    countryCode: string,
    languageCode: string,
    data: Subtopic
  ) => Promise<void>;
  deleteSubtopic: (countryCode: string, subtopicId: number) => Promise<void>;
}

export const subtopicRepository: SubtopicRepository = {
  getSubtopics: (countryCode, languageCode, topicId) => {
    return subtopicRepositoryImplementation.getSubtopics(
      countryCode,
      languageCode,
      topicId
    );
  },
  getAllSubtopics: (countryCode, languageCode) => {
    return subtopicRepositoryImplementation.getAllSubtopics(
      countryCode,
      languageCode
    );
  },
  getSubtopic: (countryCode, languageCode, subtopicId) => {
    return subtopicRepositoryImplementation.getSubtopic(
      countryCode,
      languageCode,
      subtopicId
    );
  },
  updateSubtopic: (countryCode, languageCode, data) => {
    return subtopicRepositoryImplementation.updateSubtopic(
      countryCode,
      languageCode,
      data
    );
  },
  createSubtopic: (countryCode, languageCode, data) => {
    return subtopicRepositoryImplementation.createSubtopic(
      countryCode,
      languageCode,
      data
    );
  },
  deleteSubtopic: (countryCode, subtopicId) => {
    return subtopicRepositoryImplementation.deleteSubtopic(
      countryCode,
      subtopicId
    );
  }
};
